import { render, staticRenderFns } from "./LeadNewLeadsColumn.vue?vue&type=template&id=2bccb24a&"
import script from "./LeadNewLeadsColumn.vue?vue&type=script&lang=js&"
export * from "./LeadNewLeadsColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports